var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  fill: "#464646",
  r: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14,17.58a1,1,0,0,1-.92-.6,1,1,0,0,1,.52-1.32,4,4,0,1,0-3.2,0,1,1,0,1,1-.8,1.83,6,6,0,1,1,4.8,0A1,1,0,0,1,14,17.58Z",
  fill: "#464646"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14,21.77a1,1,0,0,1-.22-2,8,8,0,1,0-3.56,0A1,1,0,0,1,11,21a1,1,0,0,1-1.2.75A10,10,0,1,1,22,12a9.93,9.93,0,0,1-7.78,9.74A.83.83,0,0,1,14,21.77Z",
  fill: "#464646"
});

function SvgSessionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionIcon);
export default __webpack_public_path__ + "static/media/session-icon.de13b0401a71c8b2ee17117134dabd57.svg";
export { ForwardRef as ReactComponent };